import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const ReportContext = createContext();

const ReportProvider = ({ children }) => {
  const [selectedStudentId, setSelectedStudentId] = useState(0);
  const [studentName, setStudentName] = useState('');
  const [selectedClassId, setSelectedClassId] = useState(-1);
  const [selectedCourseId, setSelectedCourseId] = useState(-1);
  const [assignmentId, setAssignmentId] = useState(null);
  const [includeRetakes, setIncludeRetakes] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isAllReport, setIsAllReport] = useState(false);
  const [studentToIncludeTab, setStudentToIncludeTab] = useState(0);
  const [courseName, setCourseName] = useState('');
  const [className, setClassName] = useState('');
  const [isAssessment, setIsAssessment] = useState(false);
  const [scoreTypeTab, setScoreTypeTab] = useState(0);
  const [reportType, setReportType] = useState('');

  return (
    <ReportContext.Provider value={{ selectedStudentId, setSelectedStudentId, studentName, setStudentName, selectedClassId, setSelectedClassId,
      assignmentId, setAssignmentId, includeRetakes, setIncludeRetakes, selectedCourseId, setSelectedCourseId, startDate, setStartDate, endDate, setEndDate,
      isAllReport, setIsAllReport, studentToIncludeTab, setStudentToIncludeTab, courseName, setCourseName, className, setClassName, isAssessment, setIsAssessment,
      scoreTypeTab, setScoreTypeTab, reportType, setReportType}}>
      {children}
    </ReportContext.Provider>
  );
};

ReportProvider.propTypes = {
  children: PropTypes.any
};

export const useReportContext = () => useContext(ReportContext);
export { ReportProvider };